import React, { useEffect } from 'react';
import Observer from 'react-intersection-observer';
import { GAfireEvent } from '../Tracking';
import { isEs } from "../../libs/lang";
import {fireTag} from '../../libs/analytics';
//import content from '../../content';

/* eslint-disable global-require */
let content = {};

if (isEs()) {
	content = require('../../contentES').default.home;
}
else {
	content = require('../../content').default.home;
}

const PillarCard = ({cardNum, isMobile, enableScrollGA, id}) => {

	let redNavHeight = window.innerWidth < 570 ? 40 : isEs() ? 40 : 60;
	const cardContent = content.pillarCards[cardNum - 1];

	const isExternalLink = (href) => href.indexOf('http') > -1;

	const tabClick = (tabElem) => {
		tabElem.preventDefault();
		const tabLabel = tabElem.currentTarget.children[1].innerText.toLowerCase();
		//GAfireEvent("home_C21", {label: tabLabel});
		fireTag(`C${(17+Number(tabElem.currentTarget.getAttribute('data-tab-num')))}`);

		const scrollVal = window.innerWidth < 1080 ? tabElem.currentTarget.offsetTop - 1 : tabElem.currentTarget.offsetTop - redNavHeight - 1;
		document.documentElement.scrollTo({top: scrollVal, left: 0, behavior: 'smooth'});
	}

	useEffect(() => {
		const masthead = document.getElementById('masthead');
		const homePageFirstTab = document.querySelector('a.tab_1') || false;
		const homePageSecondTab = document.querySelector('a.tab_2') || false;
		const tabBackground = document.querySelector('.tab-background');

		if (homePageFirstTab) {
			window.addEventListener('scroll', () => {
				if (homePageFirstTab.getBoundingClientRect().top < redNavHeight) {
					masthead.classList.add('relative');
					tabBackground.classList.add('show');
				}
				else {
					masthead.classList.remove('relative');
					tabBackground.classList.remove('show');

				}
			});
		}
		if (homePageSecondTab) {
			window.addEventListener('scroll', () => {
				if (homePageFirstTab.getBoundingClientRect().top < redNavHeight) {
					tabBackground.classList.add('show');
					masthead.classList.add('relative');
				}
				else {
					tabBackground.classList.remove('show');
					masthead.classList.remove('relative');
				}
			});
		}
	})

	// console.log(id)
	const cardIds = ["housing", "sustainability", "small-biz", "financial-health"];
	const cardSections = ["housing", "sustainability and climate", "small business growth", "financial health"];
	const cardSectionsES = ["viviendas", "la sostenibilidad y el clima", "crecimiento de pequeñas empresas", "bienestar financiero"];
	const cardId = Number(id.slice(-1)) - 1;
	// console.log(cardId);

	return (
		<Observer
			id={cardIds[cardId]}
			className="pillar-card-observer"
			threshold={0.75}
			triggerOnce
			onChange={inView => {
				if (inView && enableScrollGA) {
					//GAfireEvent(`home_S${cardNum}`);
					//fireTag("S"+(cardNum));
				}
			}}
		>
			<div className={`tab-background ${cardNum !== 1 ? 'show' : ''}`}>
				<div className='tab-pillar'>
					<a
						className={`tab tab_${cardNum}`}
						href={`#tab-${cardNum}`}
						onClick={e => tabClick(e)}
						data-tab-num={cardNum}
					>
						<span className='tab-icon'><img src={`${process.env.PUBLIC_URL}${cardContent.icon.src}`} alt={''}/></span>
						<span className='tab-text'>{cardContent.tabLabel}</span>
					</a>
				</div>
			</div>
			<div className={`folder folder_${cardNum}`}>
				<div className='pillar-card' data-card-num={cardNum}>
					<div className='card-group-desktop-right'>
						<img lang={isEs() ? 'es' : 'en'} className='card-image' src={`${process.env.PUBLIC_URL}${cardContent.img.src}`} alt={cardContent.img.alt}/>
						{!isMobile && (
							<div className='quote-container'>
								{cardContent.quote.href ? (
									<a href={(isExternalLink(cardContent.quote.href) ? cardContent.quote.href : `${process.env.PUBLIC_URL}${cardContent.quote.href}`)} target={cardContent.quote.target}>
										<q>{cardContent.quote.text}</q>
									</a>
								) : (
									isEs() ? <span className="quote">{cardContent.quote.text}</span> : <q>{cardContent.quote.text}</q>
								)}
								<div className='attrib-container'>
									<p className='attrib-name'>{cardContent.quote.attrib}</p>
									<p className='attrib-title'>{cardContent.quote.attribTitle}</p>
								</div>
							</div>
						)}
					</div>
					<div className='card-group-desktop-left'>
						<div className='bar'/>
						<h2>{cardContent.headline}</h2>
						<p className='pillar-copy'>{cardContent.body}</p>
						<ul className='stats-container'>
							{cardContent.stats.map((stat, i) => (
								// eslint-disable-next-line react/no-array-index-key
								<li className='stat-item' key={`stat-${i}`}>{stat.text}</li>
							))}
						</ul>
						{cardContent.cta && (
							<div className='cta-container'>
								<p className='cta-intro'>{cardContent.cta.intro}</p>
								{/* eslint-disable-next-line react/jsx-no-target-blank */}
								{
									isEs() ?
										// eslint-disable-next-line react/jsx-no-target-blank
										<a
											className={`cta-link es ${cardContent.cta.href.includes('sustainability') ? 'sustainability' : ''}${cardContent.id.includes('small business') ? 'small-business' : ''}`}
											href={
												(isExternalLink(cardContent.cta.href) ? cardContent.cta.href : `${process.env.PUBLIC_URL}${cardContent.cta.href.includes('sustainability') ? window.location.origin + '/impact' + cardContent.cta.href : cardContent.cta.href}`)}
											onClick={(e) => {
												if (!cardContent.cta.newTab) {
													e.preventDefault();
													window.location.href = (isExternalLink(cardContent.cta.href) ? cardContent.cta.href : `${cardContent.cta.href.includes('sustainability') ? window.location.origin + '/impact' + cardContent.cta.href : process.env.PUBLIC_URL + cardContent.cta.href}`);
												}
												if(isEs()){
													fireTag("C5", cardSectionsES[cardNum - 1]);
												} else {
													fireTag("C5", cardSections[cardNum - 1]);
												}
												//GAfireEvent("home_C5", {action: cardContent.id, label: cardContent.cta.ctaLabel})
											}}
											target={cardContent.cta.newTab ? '_blank' : ''}
											rel={cardContent.cta.newTab ? "noreferrer" : ''}
											aria-label={cardContent.cta.ariaLabel}
										>
											{cardContent.cta.ctaLabel}
										</a>
										:
										<a
											target={cardContent.cta.newTab ? '_blank' : ''}
											rel={cardContent.cta.newTab ? "noreferrer" : ''}
											className='cta-link'
											href={(isExternalLink(cardContent.cta.href) ? cardContent.cta.href : `${process.env.PUBLIC_URL}${cardContent.cta.href}`)}
											onClick={() => {fireTag('C5', 
											`${isEs() ? cardSectionsES[cardNum - 1] : cardSections[cardNum - 1]}`
											)}}
											aria-label={cardContent.cta.ariaLabel}
										>
											{cardContent.cta.ctaLabel}
										</a>
								}
							</div>
						)}
						{cardContent.story && (
							<div className='story-container'>
								<img src={`${process.env.PUBLIC_URL}${cardContent.story.img.src}`} alt={cardContent.story.img.alt}/>
								<div className='story-copy-container'>
									<a
										className={`story-link ${isEs() ? 'es' : ''}`}
										href={(isExternalLink(cardContent.story.href) ? cardContent.story.href : `${process.env.PUBLIC_URL}${cardContent.story.href}`)}
										target={cardContent.story.target && (cardContent.story.target)}
										onClick={() => {fireTag('C5', `${isEs() ? cardSectionsES[cardNum - 1] : cardSections[cardNum - 1]}`)}}
										>
										{cardContent.story.text}
									</a>
								</div>
							</div>
						)}
					</div>
					{isMobile && (
						<div className='quote-container'>
							{cardContent.quote.href ? (
								<a href={(isExternalLink(cardContent.quote.href) ? cardContent.quote.href : `${process.env.PUBLIC_URL}${cardContent.quote.href}`)}>
									<q>{cardContent.quote.text}</q>
								</a>
							) : (
								isEs() ? <>{cardContent.quote.text}</> : <q>{cardContent.quote.text}</q>
							)}
							<div className='attrib-container'>
								<p className='attrib-name'>{cardContent.quote.attrib}</p>
								<p className='attrib-title'>{cardContent.quote.attribTitle}</p>
							</div>
						</div>
					)}
				</div>
			</div>
		</Observer>
	);

};

export default PillarCard;
